/**
 * Shutdown Notice Page
 * Explains the planned retirement of TrainerDX and what happens to user data
 */

import React from "react";
import {Card, CardBody, Row, Col} from "reactstrap";
import {BackgroundColorContext} from "../contexts/BackgroundColorContext";
import PageHeader from "../components/Common/PageHeader";

function ShutdownNotice() {
  return (
    <BackgroundColorContext.Consumer>
      {() => (
        <>
          <PageHeader
            title="TrainerDX is Closing"
            subtitle="Information about the planned retirement of TrainerDX"
            icon="fa fa-info-circle"
          />
          <Row>
            <Col md="12">
              <Card>
                <CardBody className="card-copy about-us">
                  <Row>
                    <Col xs="12" md={{size: 10, offset: 1}}>
                      <h2>What is happening</h2>
                      <p>
                        TrainerDX (formerly Zwiftalizer) will shut down at midnight Pacific Time on November 30th, 2026.
                        After that date the website and all of its tools will no longer be available.
                      </p>

                      <h2>Registrations and tokens</h2>
                      <p>
                        New registrations are no longer accepted, and token purchases have been disabled. Existing
                        accounts can continue to use the site until the shutdown date. Payments made since September 30,
                        2026 will be refunded.
                      </p>

                      <h2>Why</h2>
                      <p>
                        TrainerDX began in 2016 as a personal project and has always been a one-person operation. The
                        problems it was built to diagnose have become much less common. Hardware has improved to the
                        point where the GPU benchmarks no longer provide the value they did in 2016 (Apple silicon can
                        now run the High and Ultra profiles, for example), and the spread of Bluetooth has made device
                        connectivity far more reliable. Usage has declined steadily since early 2025, and I no longer
                        have the time to maintain the site. I haven't ridden Zwift in several years myself. Rather than
                        let TrainerDX slowly break, I'd prefer to close it cleanly.
                      </p>

                      <h2>Is this a security incident?</h2>
                      <p>
                        <strong>No.</strong> This is a planned retirement. It is not related to a security incident or
                        data breach, and no breach has occurred.
                      </p>

                      <h2>What happens to your data</h2>
                      <p>
                        On or before the shutdown date, all uploaded logs, generated reports, and account information,
                        including email addresses, will be permanently deleted. Your data was never sold, and it will
                        not be transferred to anyone.
                      </p>
                      <p>
                        If there is anything you want to keep from your reports, such as screenshots or notes, please
                        save it before November 30th.
                      </p>

                      <h2>Questions</h2>
                      <p>
                        If you have questions or concerns, please use the <a href="/contact">contact form</a>. I read
                        every message, though it sometimes takes me a few days to respond.
                      </p>

                      <hr className="my-4" />

                      <p className="text-center text-muted">
                        <em>Thank you to everyone who used TrainerDX over the past ten years.</em>
                      </p>
                      <p className="text-center text-muted">
                        <em>
                          A special thank you to everyone who supported the site with donations and token purchases.
                        </em>
                      </p>
                      <p className="text-center text-muted">
                        <strong>- Mike Hanney</strong>
                      </p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </BackgroundColorContext.Consumer>
  );
}

export default ShutdownNotice;
